import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
/**
 * Estilização consistente para teclas de atalho inline no texto.
 * Aceita várias teclas separadas por espaço: <Kbd>Mod+E</Kbd>.
 */
export function Kbd({ children, className, }) {
    return (_jsx("kbd", { className: cn('inline-flex items-center gap-0.5 font-mono text-[10px] font-bold', 'px-1.5 py-0.5 rounded border border-border bg-muted text-foreground', 'shadow-[0_1px_0_rgba(0,0,0,0.08)_inset]', className), children: children }));
}
